export type SortDirection = 'asc' | 'desc'

export function sortByDate<T>(items: T[], dateSelector: (item: T) => Date, direction: SortDirection = 'asc'): T[] {
  if(items.length === 0) return []
  
  const sortModifier = direction === 'asc' ? 1 : -1
  return [...items].sort((a, b) => {
    const dateA = dateSelector(a)
    const dateB = dateSelector(b)
    return (dateA.getTime() - dateB.getTime()) * sortModifier
  })
}

export function sortByNumber<T>(items: T[], numberSelector: (item: T) => number, direction: SortDirection = 'asc'): T[] {
  if(items.length === 0) return []

  const sortModifier = direction === 'asc' ? 1 : -1
  return [...items].sort((a, b) => {
    const numA = numberSelector(a)
    const numB = numberSelector(b)
    return (numA - numB) * sortModifier
  })
}

export function sortByString<T>(items: T[], stringSelector: (item: T) => string, direction: SortDirection = 'asc', locale: string = 'sv'): T[] {
  if(items.length === 0) return []

  const sortModifier = direction === 'asc' ? 1 : -1
  return [...items].sort((a, b) => {
    const strA = stringSelector(a)
    const strB = stringSelector(b)
    return strA.localeCompare(strB, locale) * sortModifier
  })
}